var React = require('react');

function EventInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.2002 9.5H1.2002M14.2002 1.5V5.5M6.2002 1.5V5.5M6.0002 21.5H14.4002C16.0804 21.5 16.9204 21.5 17.5622 21.173C18.1267 20.8854 18.5856 20.4265 18.8732 19.862C19.2002 19.2202 19.2002 18.3802 19.2002 16.7V8.3C19.2002 6.61984 19.2002 5.77976 18.8732 5.13803C18.5856 4.57354 18.1267 4.1146 17.5622 3.82698C16.9204 3.5 16.0804 3.5 14.4002 3.5H6.0002C4.32004 3.5 3.47996 3.5 2.83822 3.82698C2.27374 4.1146 1.8148 4.57354 1.52718 5.13803C1.2002 5.77976 1.2002 6.61984 1.2002 8.3V16.7C1.2002 18.3802 1.2002 19.2202 1.52718 19.862C1.8148 20.4265 2.27374 20.8854 2.83822 21.173C3.47996 21.5 4.32004 21.5 6.0002 21.5Z","stroke":"#407A7D","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

EventInline.defaultProps = {"width":"21","height":"23","viewBox":"0 0 21 23","fill":"none"};

module.exports = EventInline;

EventInline.default = EventInline;
